import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import { Typography, Chip } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseIcon from "@material-ui/icons/Close";
import {
  setFilterNtt,
  setReportFilterNtt,
  getSavedSelectedTagDataByEmail,
  getHomeImageDataNtt,
  setCurrentPageNumber,
  getReportDataNtt,
} from "../../actions";
import TagConfig from "../../config/TagConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      width: 500,
      height: "100vh",
      padding: 16,
      boxSizing: "border-box",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    filter: {
      marginLeft: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    filterItem: {
      marginTop: theme.spacing(4),
    },
    filterButtonContainer: {
      position: "absolute",
      bottom: 45,
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
      display: "flex",
      justifyContent: "space-around",
    },
    formControl: {
      margin: theme.spacing(1),
      width: "89%",
    },
    dataBtn: {
      minWidth: 200,
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
    },
    tagSelect: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontSize: 16,
      minWidth: 416,
      maxWidth: 416,
      "& .MuiInputLabel-root": {
        fontSize: "16px", // Smaller font size for the label (placeholder)
      },
      "& .MuiInputBase-input": {
        fontSize: "16px", // Customize input text size (if needed)
      },
    },
    scrollArea: {
      flexGrow: 1,
      overflowY: "auto",
      paddingRight: 8,
      paddingBottom: 16,
      marginBottom: 80,
    },
    header: {
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
    },
    closeButton: {
      position: "absolute",
      top: 10,
      left: 8,
      zIndex: 10,
    },
    titleText: {
      fontSize: "1rem",
      fontWeight: "bold",
      marginLeft: 42,
    },
  })
);

const FilterDrawerNtt = ({
  currentPage,
  periodType,
  toggleDrawer,
  anchor,
  setFilterNtt,
  setReportFilterNtt,
  filterStoreNtt,
  reportFilterStoreNtt,
  getSavedSelectedTagDataByEmail,
  getHomeImageDataNtt,
  setCurrentPageNumber,
  filterType,
  reportTagFilterDataNtt,
  getReportDataNtt,
}) => {
  const classes = useStyles();
  const [sort, setSort] = useState(`${filterStoreNtt.type}-${filterStoreNtt.order}`);
  const [assetId, setAssetId] = useState("");
  const [tagData, setTagData] = useState([]);
  const [tagDataResult, setTagDataResult] = useState(
    TagConfig.resultTagNttOption
  );
  const [assetType, setAssetType] = useState("");
  const sortPrefix = filterType === "photo" ? "撮影" : "報告";
  const tagLabel = filterType === "photo" ? "結果タグ" : "報告タグ";

  useEffect(() => {
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.filterType = filterType;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  }, [currentPage]);

  useEffect(() => {
    setAssetId(
      filterType === "photo" ? filterStoreNtt.assetId : reportFilterStoreNtt.assetId
    );
  }, [filterStoreNtt.assetId, reportFilterStoreNtt.assetId]);

  useEffect(() => {
    setAssetType(
      filterType === "photo"
        ? filterStoreNtt.assetType
        : reportFilterStoreNtt.assetType
    );
  }, [filterStoreNtt.assetType, reportFilterStoreNtt.assetType]);


  useEffect(() => {
    if (reportTagFilterDataNtt.length > 0) {
      const tagData = reportTagFilterDataNtt.map((tag) => ({
        value: tag.value,
        label: tag.label,
        tip: tag.tip,
        count: tag.count,
      }));
      setTagData(tagData);
    }
  }, [reportTagFilterDataNtt]);

  const handleAssetTypeChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.assetType = value;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handlePrefecturalArea = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.prefecturalArea = value;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handleExchangeOfficeName = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.exchangeOfficeName = value;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handlePhotoTypeChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.photoType = value;
    //copyFilter.twoStepVerification = "all";
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handleTwoStepVerificationeChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.twoStepVerification = value;
    copyFilter.photoType = "all";
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handleResultTagChange = (event) => {
    const value = event.target.value;
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt };
    copyFilter.resultTag = value;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handleChange = (event) => {
    const filterValue = event.target.value.split("-");
    const filter = {
      type: filterValue[0],
      order: filterValue[1],
      tag: filterType === "photo" ? filterStoreNtt.tag : reportFilterStoreNtt.tag,
      filterType: filterType,
      assetId:
        filterType === "photo"
          ? filterStoreNtt.assetId
          : reportFilterStoreNtt.assetId,
      assetType:
        filterType === "photo"
          ? filterStoreNtt.assetType
          : reportFilterStoreNtt.assetType,
    };
    setSort(event.target.value);
    if (filterType === "photo") {
      setFilterNtt(filter);
    } else if (filterType === "report") {
      setReportFilterNtt(filter);
    }
  };

  const fetchData = () => {
    if (filterStoreNtt.tag !== undefined && filterStoreNtt.tag.length > 0) {
      getSavedSelectedTagDataByEmail();
    } else {
      if (currentPage.includes("report")) {
        getReportDataNtt({
          pageNumber: 1,
        });
      } else {
        getHomeImageDataNtt({
          pageNumber: 1,
        });
      }
    }
    setCurrentPageNumber(1);
    toggleDrawer(anchor, false)();
  };

  const handleReset = () => {
    if (filterType === "photo") {
      setFilterNtt({
        type: "occurred_datetime",
        order: "desc",
        tag: [],
        filterType: "photo",
        assetId: null,
        prefecturalArea: "all",
        exchangeOfficeName: "all",
        photoType: "all",
        twoStepVerification: "all",
        resultTag: "all",
        assetType: "all",
      });
    } else if (filterType === "report") {
      setReportFilterNtt({
        type: "occurred_datetime",
        order: "desc",
        tag: [],
        tagResult: [],
        filterType: "report",
        assetId: null,
        assetType: "all",
        reportTime: "all",
      });
    }
    setAssetId("");
    setSort("occurred_datetime-desc");
    setAssetType("");
    toggleDrawer(anchor, false)();
    setCurrentPageNumber(1);
    if (filterType === "photo") {
      getHomeImageDataNtt({
        pageNumber: 1,
      });
    } else {
      getReportDataNtt({
        pageNumber: 1,
      });
    }
  };

  const handleSelectTagChange = (tags) => {
    let copyFilter =
      filterType === "photo" ? { ...filterStoreNtt } : { ...reportFilterStoreNtt};
    copyFilter.tag = tags;
    if (filterType === "photo") {
      setFilterNtt(copyFilter);
    } else if (filterType === "report") {
      setReportFilterNtt(copyFilter);
    }
  };

  const handleSelectReportTagResultChange = (tagResult) => {
    let copyFilter = { ...reportFilterStoreNtt };
    copyFilter.tagResult = tagResult;
    setReportFilterNtt(copyFilter);
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton
          className={classes.closeButton}
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer(anchor, false)}
          disableRipple={true}
          disableFocusRipple={true}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" className={classes.titleText}>
          絞り込み条件設定
        </Typography>
      </div>
      <div className={classes.scrollArea}>
        <Grid
          container
          direction="column"
          justifyContent={"flex-start"}
          className={classes.filter}
        >
          <Grid item className={classes.filterItem}>
            <TextField
              id="prefecturalArea"
              label="県域"
              variant="outlined"
              style={{ width: "89%", paddingLeft: 6 }}
              value={filterType === "photo"
                ? filterStoreNtt.prefecturalArea !== "all" ? filterStoreNtt.prefecturalArea : ""
                : reportFilterStoreNtt.prefecturalArea !== "all" ? reportFilterStoreNtt.prefecturalArea : ""
              }
              onChange={handlePrefecturalArea}
            />
          </Grid>
          <Grid item className={classes.filterItem}>
            <TextField
              id="exchangeOfficeName"
              label="収容局名"
              variant="outlined"
              style={{ width: "89%", paddingLeft: 6 }}
              value={filterType === "photo"
                ? filterStoreNtt.exchangeOfficeName !== "all" ? filterStoreNtt.exchangeOfficeName : ""
                : reportFilterStoreNtt.exchangeOfficeName !== "all" ? reportFilterStoreNtt.exchangeOfficeName : ""
              }
              onChange={handleExchangeOfficeName}
            />
          </Grid>
          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-assetType-label">撮影種別</InputLabel>
              {periodType === "season" && (
                <Select
                  labelId="simple-select-assetType-label"
                  id="simple-select-assetType"
                  value={filterType === "photo" ? filterStoreNtt.photoType : reportFilterStoreNtt.photoType}
                  onChange={handlePhotoTypeChange}
                  label="撮影種別"
                >
                  <MenuItem value="all">全て</MenuItem>
                  <MenuItem value="CONCRETE">メーカー調査（すべて）</MenuItem>
                  <MenuItem value="CONCRETE_LUCKY">メーカー調査（２段階判定対象）</MenuItem>
                  <MenuItem value="CONCRETE_REGULAR">メーカー調査（２段階判定対象外）</MenuItem>
                  <MenuItem value="STEEL">地際調査（すべて）</MenuItem>
                  <MenuItem value="STEEL_LUCKY">地際調査（２段階判定対象）</MenuItem>
                  <MenuItem value="STEEL_REGULAR">地際調査（２段階判定対象外）</MenuItem>
                  <MenuItem value="TARGET_LUCKY">2段階判定対象</MenuItem>
                  <MenuItem value="TARGET_REGULAR">2段階判定対象外</MenuItem>
                </Select>
              )}
            </FormControl>
          </Grid>
          {filterType === "report" &&
            <Grid item className={classes.filterItem}>
              <Autocomplete
                multiple
                id="filter-tag-select"
                options={tagData}
                noOptionsText="データがありません"
                getOptionLabel={(option) => option.value || ""}
                getOptionSelected={(option, value) =>
                  option.value.toString() === value.toString()
                }
                value={
                  filterType === "photo"
                    ? filterStoreNtt.tag !== undefined && filterStoreNtt.tag.length > 0
                      ? tagData.filter((tag) =>
                          filterStoreNtt.tag.includes(tag.value.toString())
                        )
                      : []
                    : reportFilterStoreNtt.tag !== undefined &&
                      reportFilterStoreNtt.tag.length > 0
                    ? tagData.filter((tag) =>
                        reportFilterStoreNtt.tag.includes(tag.value.toString())
                      )
                    : []
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    const selectedValues = newValue.map((tag) =>
                      tag.value.toString()
                    );
                    handleSelectTagChange(selectedValues);
                  } else {
                    handleSelectTagChange([]);
                  }
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={index}
                      size="small"
                      label={option.value}
                      {...getTagProps({ index })}
                      style={{ backgroundColor: "#f3ee91", color: "black" }}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={tagLabel}
                    className={classes.tagSelect}
                  />
                )}
                renderOption={(option) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body1">
                      <b>{option.label}</b> : {option.tip} ({option.count})
                    </Typography>
                  </div>
                )}
              />
            </Grid>
          }
          {filterType !== "report" && (
          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-doubleCheck-label">
                ME判定結果
              </InputLabel>
              {periodType === "season" && (
                <Select
                  labelId="simple-select-doubleCheck-label"
                  id="simple-select-doubleCheck"
                  value={filterType === "photo" ? filterStoreNtt.resultTag : reportFilterStoreNtt.resultTag}
                  onChange={handleResultTagChange}
                  label="ME判定結果"
                >
                  <MenuItem value="all">全て</MenuItem>
                  <MenuItem value="true">合格</MenuItem>
                  <MenuItem value="false">不合格</MenuItem>
                  <MenuItem value="pending">保留</MenuItem>
                  <MenuItem value="unchecked">-（未確認）</MenuItem>
                </Select>
              )}
            </FormControl>
          </Grid>
          )}
          <Grid item className={classes.filterItem}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-sort-label">ソート</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={sort}
                onChange={handleChange}
                label="ソート"
              >
                <MenuItem value="occurred_datetime-desc">
                  {sortPrefix}日時 - 降順
                </MenuItem>
                <MenuItem value="occurred_datetime-asc">
                  {sortPrefix}日時 - 昇順
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <div className={classes.filterButtonContainer}>
            <Button
              className={classes.dataBtn}
              variant="contained"
              color="primary"
              onClick={fetchData}
            >
              絞り込む
            </Button>
            <Button
              className={classes.dataBtn}
              variant="contained"
              color="default"
              onClick={handleReset}
            >
              リセット
            </Button>
          </div>
        </Grid>
      </div>
    </div>
  );
};

FilterDrawerNtt.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
  periodType: state.app.periodType,
  filterStoreNtt: state.home.filterNtt,
  reportFilterStoreNtt: state.report.filterNtt,
  reportTagFilterDataNtt: state.report.reportTagFilterDataNtt,
});

const mapDispatchToProps = (dispatch) => ({
  setFilterNtt: (param) => dispatch(setFilterNtt(param)),
  setReportFilterNtt: (param) => dispatch(setReportFilterNtt(param)),
  getSavedSelectedTagDataByEmail: () => dispatch(getSavedSelectedTagDataByEmail()),
  getHomeImageDataNtt: (param) => dispatch(getHomeImageDataNtt(param)),
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  getReportDataNtt: (param) => dispatch(getReportDataNtt(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(FilterDrawerNtt));
